// extracted by mini-css-extract-plugin
export default {"next_order":"Zt","recurringdis":"au","reactivate_button":"bu","order__summary_title":"cu","order__summary_items":"eu","order__summary_item":"fu","order__summary_item_title":"gu","order__summary_item_quantity":"hu","order__item_separator":"iu","discount":"ju","promowrapper":"ku"};
    if(module.hot) {
      // 1713361644072
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  